// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-wrapper:hover .st0,\n.icon-wrapper:hover .st1,\n.icon-wrapper:hover .st2,\n.icon-wrapper:hover .st3 {\n\tstroke: #f1560f !important;\n}\n", ""]);
// Exports
module.exports = exports;
